import React from 'react';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import infoIcon from '../../../assets/images/info-icon-black.svg';

const constrainTooltipPosition = ({ left, top }, _event, target, node) => {
  const viewportMargin = 16;
  const maxLeft = Math.max(
    viewportMargin,
    window.innerWidth - node.offsetWidth - viewportMargin
  );
  const constrainedLeft = Math.min(Math.max(left, viewportMargin), maxLeft);
  const targetRect = target.getBoundingClientRect();

  node.style.setProperty(
    '--info-tooltip-arrow-left',
    `${targetRect.left + targetRect.width / 2 - constrainedLeft}px`
  );

  return {
    left: constrainedLeft,
    top,
  };
};

const StyledInfoCircle = styled.span`
  display: inline-flex;
  font-size: 18px;
  line-height: 11px;
  margin-left: 0.25rem;

  .info-circle-icon {
    margin-bottom: 0.5rem;
  }

  .info-tooltip {
    padding: 1rem 0.75rem;
  }
`;

export const InfoCircle = ({
  text,
  tooltipContent,
  clickable,
  id,
  withoutTooltip,
  tooltipClassName,
}) => {
  const tooltipId = id || String(Number(new Date()));

  if (withoutTooltip) {
    return (
      <StyledInfoCircle>
        <img
          className="info-circle-icon"
          src={infoIcon}
          width="16"
          height="16"
          alt="Provide additional information on this field."
        />
      </StyledInfoCircle>
    );
  }

  return (
    <StyledInfoCircle>
      <ReactTooltip
        id={tooltipId}
        place="top"
        effect="solid"
        multiline={true}
        clickable={clickable}
        className={`info-tooltip ${tooltipClassName || ''}`.trim()}
        overridePosition={constrainTooltipPosition}
        isCapture
      >
        {tooltipContent || <span>{text}</span>}
      </ReactTooltip>
      <span
        data-for={tooltipId}
        data-tip
        onTouchStart={(e) => ReactTooltip.show(e.currentTarget)}
      >
        <img
          className="info-circle-icon"
          src={infoIcon}
          width="16"
          height="16"
          alt="Provide additional information on this field."
        />
      </span>
    </StyledInfoCircle>
  );
};
